import React from 'react';
import Table from '../../../../componentes/table';
import { Row, Col } from 'src/componentes/grid';
import Button from '../../../../componentes/button';
import ItemList from '..';
import ContentManager from '../../../../componentes/content-manager';
import IconButton from '../../../../componentes/icon-button';
import { FormattedMessage } from 'react-intl';
import { capitalizeFirstLetter } from '../../../../utils/string';
import { useSelector } from 'react-redux';

const TabelaProcessosAssociados = ({
  model,
  allowNew = true,
  itemIdIgnorar,
}) => {
  const resources = useSelector((state) => state.user.termos);

  const handleSelect = (itens) => {
    let itensAtuais = [...model.value];
    itensAtuais.forEach((item) => itens.push(item));
    model.requestChange([...itens]);
  };

  const handleNewClick = () => {
    ContentManager.addContent(
      <ItemList
        parameters={{ parentId: 0, itemIdIgnorar }}
        showModal={true}
        multiple
        disabled
        showExport={false}
        select={true}
        selectedCallback={handleSelect}
        selectedIds={model.value}
      />
    );
  };

  const handleRemove = (item, index) => {
    const novaLista = [...model.value];
    novaLista.splice(index, 1);
    model.requestChange(novaLista);
  };

  return (
    <div>
      <Row>
        <Col md={6}>
          {model.label && (
            <label className="control-label">{model.label}</label>
          )}
        </Col>
        <Col md={6}>
          {allowNew && (
            <Button
              className="pull-right"
              leftIcon="magnify"
              type="primary"
              style={{ marginBottom: 10 }}
              onClick={handleNewClick}
            >
              <FormattedMessage id="label.buscar" />
            </Button>
          )}
        </Col>
      </Row>
      {model.value && model.value.length > 0 ? (
        <Table>
          <thead>
            <tr>
              <th>
                <FormattedMessage id="nome" />
              </th>
              <th>
                <FormattedMessage id="codigo" />
              </th>
              <th>{capitalizeFirstLetter(resources.responsaveis)}</th>
              <th>{capitalizeFirstLetter(resources.area)}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {model.value.map(
              (item, index) =>
                !item.excluido && (
                  <tr key={item.id || index}>
                    <td>{item.nome}</td>
                    <td>{item.idIntegracao}</td>
                    <td>{item.responsaveis}</td>
                    <td>{item.area}</td>
                    <td style={{ width: 40 }}>
                      {allowNew && (
                        <IconButton
                          icon="close-circle"
                          className="clarear"
                          onClick={() => handleRemove(item, index)}
                        />
                      )}
                    </td>
                  </tr>
                )
            )}
          </tbody>
        </Table>
      ) : (
        <i>
          <FormattedMessage id="label.naoHaItensRelacionados" />
        </i>
      )}
    </div>
  );
};

export default TabelaProcessosAssociados;
